// extracted by mini-css-extract-plugin
export default {"ecolabel":"EcoLabel__ecolabel--UoLKx"};